import { gql } from "@apollo/client";

export default gql`
  mutation unpinAiEngine($data: AiEngineUnpinInput!){
    unpinAiEngine(data: $data){
        success
        data{
            engines{
                version
                capabilities
                frozen
            }
            capabilities
            routing{
                defaults{
                    capability
                    version
                }
                pins{
                    customerId
                    capability
                    version
                    note
                    createdBy
                    createdAt
                }
                disabled{
                    capability
                    version
                    reason
                    createdBy
                    createdAt
                }
                history{
                    index
                    at
                    by
                    reason
                    snapshot{
                        defaults{
                            capability
                            version
                        }
                        pins{
                            customerId
                            capability
                            version
                            note
                            createdBy
                            createdAt
                        }
                        disabled{
                            capability
                            version
                            reason
                            createdBy
                            createdAt
                        }
                    }
                }
                updatedBy
                updatedAt
            }
        }
        code
        message
    }
}
`
